import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { get_Date, commaSeprateString } from "../../Utils/commonFunctions";
import {
  PDFDownloadLink,
  Page,
  Text,
  Image,
  Document,
  Svg,
} from "@react-pdf/renderer";
import {
  QuestionOptionDownload,
  UserTextResponcesReportPdf,
} from "./commonComponent";
import { getFinalSurveyAnalysisReportDownload } from "../../Utils/adminFunctions";

function UserAnalysisReportDownload() {
  const [surveyData, setSurveyData] = useState("");
  const [analysisReport, setAnalysisReport] = useState("");
  const { surveyID } = useParams();
  useEffect(() => {
    UserSurveyAnalysisReportDownload();
  }, []);
  const UserSurveyAnalysisReportDownload = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    const response = await getFinalSurveyAnalysisReportDownload(bodyFormData);

    if (response.status == "success") {
      setSurveyData(response.data.survey_result[0]);
      let colors = response.data.survey_result[0].COLOR;
      if (Object.keys(response.data.anyreports).length === 0) {
        setAnalysisReport("");
      } else {
        let dataObject = response.data.anyreports;
        let isChart,
          options,
          reportChartsData,
          textResponcesData,
          tempChartData,
          tempTextResponces;
        let analysisReport = Object.keys(dataObject).map(function (key, index) {
          let questionType = dataObject[key].type;
          let breakPoint = "";
          if (dataObject[key].reportscharts.length === 0) {
            isChart = 0;
            tempChartData = "";
          } else {
            isChart = 1;
            reportChartsData = dataObject[key].reportscharts;
            tempChartData = Object.keys(reportChartsData).map(function (
              key,
              index2
            ) {
              let item = reportChartsData[key];
              if (index2 != 0) {
                breakPoint = "break";
              }
              return (
                <>
                  <div
                    style={{
                      border: 1,
                      borderRadius: 5,
                      borderColor: "#dee2e6",
                      marginTop: "3%",
                      marginLeft: "1.2%",
                    }}
                    break={breakPoint}
                    key={index2}
                  >
                    <Image src={item.analysis_graph_img} />

                    <div style={{ marginLeft: 20 }}>
                      <Text style={{ fontSize: 10, margin: 4 }}>Region:</Text>

                      <Text style={{ fontSize: 10, margin: 4 }}>
                        {commaSeprateString(item.graph_region)}
                      </Text>

                      <Text style={{ fontSize: 10, margin: 4 }}>Country: </Text>

                      <Text style={{ fontSize: 10, margin: 4 }}>
                        {commaSeprateString(item.graph_country)}
                      </Text>

                      <Text style={{ fontSize: 10, margin: 4 }}>
                        Profession:{" "}
                      </Text>

                      <Text style={{ fontSize: 10, margin: 4 }}>
                        {commaSeprateString(item.graph_profession)}
                      </Text>
                    </div>
                  </div>
                </>
              );
            });
          }
          if (dataObject[key].options === "") {
            options = "";
          } else {
            options = dataObject[key].options;
          }
          if (dataObject[key].textresponse.length === 0) {
            tempTextResponces = "";
          } else {
            let isInclude = dataObject[key].isinclude;
            if (isInclude === 1) {
              textResponcesData = dataObject[key].textresponse;
              tempTextResponces = (
                <div
                  style={{
                    border: 1,
                    borderRadius: 5,
                    borderColor: "#dee2e6",
                    marginTop: "3%",
                    marginLeft: "1.2%",
                  }}
                >
                  <div
                    style={{
                      padding: "5px",
                      borderColor: "#dee2e6",
                      backgroundColor: "#f7f7f7",
                    }}
                  >
                    <Text style={{ fontSize: 10 }}>Text Responses</Text>
                  </div>
                  {Object.keys(textResponcesData).map(function (key, index3) {
                    let TextitemData = textResponcesData[key];
                    return (
                      <UserTextResponcesReportPdf
                        label={TextitemData.label}
                        key={index3}
                        textResponseItem={TextitemData.textresponseitem}
                      />
                    );
                  })}
                </div>
              );
            } else {
              tempTextResponces = "";
            }
          }
          return (
            <>
              <div
                style={{
                  border: 1,
                  padding: 6,
                  borderRadius: 5,
                  marginTop: "3%",
                  borderColor: "#006cb5",
                  marginLeft: "1.2%",
                }}
                key={index}
              >
                <Text style={{ fontSize: 11 }}>
                  <Text
                    style={{
                      backgroundColor: "#006cb5",
                      width: "30px",
                      color: "#ffffff",
                      borderRadius: "5px",
                      marginRight: "1rem",
                    }}
                  >
                    {index + 1}.
                  </Text>{" "}
                  {dataObject[key].label}
                  {dataObject[key].type === "survey"
                    ? " > " + dataObject[key].survey_label
                    : ""}
                </Text>
              </div>
              {(questionType === "radio" ||
                questionType === "selectboxes" ||
                questionType === "survey") && (
                <Svg>
                  <QuestionOptionDownload
                    questionType={questionType}
                    isChart={isChart}
                    options={options}
                    colors={colors}
                  />
                </Svg>
              )}
              {tempChartData != "" && tempChartData}
              {tempTextResponces != "" && tempTextResponces}
            </>
          );
        });
        setAnalysisReport(analysisReport);
      }
    }
  };
  const MyDocument = () => (
    <Document>
      <Page size="A4" style={{ padding: "30px" }}>
        <Image
          style={{ maxHeight: 35, marginLeft: "1.2%", maxWidth: 75 }}
          src={surveyData.manufacturer__company_logo}
          fixed
        />
        <Text
          style={{
            fontSize: 11,
            textAlign: "right",
            marginTop: "-22px",
          }}
          fixed
        >
          {surveyData.manufacturer__company_name}
        </Text>
        <div
          style={{
            flexDirection: "row",
            marginTop: "3%",
            width: "100%",
          }}
        >
          <div style={{ width: "25%" }}>
            <Text style={{ fontSize: 11, margin: 6 }}>No. of responses</Text>

            <Text style={{ fontSize: 11, margin: 6 }}>Lunch Date</Text>

            <Text style={{ fontSize: 11, margin: 6 }}>Completion Date</Text>
          </div>

          <div style={{ width: "25%" }}>
            <Text style={{ fontSize: 11, margin: 6 }}>
              {surveyData.no_of_responses}
            </Text>

            <Text style={{ fontSize: 11, margin: 6 }}>
              {get_Date(surveyData.launch_date)}
            </Text>

            <Text style={{ fontSize: 11, margin: 6 }}>
              {get_Date(surveyData.completion_date)}
            </Text>
          </div>

          <div style={{ Width: "50%" }}>
            <Image
              style={{
                maxHeight: "85px",
                maxWidth: "40%",
                alignSelf: "center",
                marginLeft: "20%",
              }}
              src={surveyData.device__device_image}
              alt="N/A"
            />
            <Text
              style={{
                fontSize: 11,
                alignSelf: "center",
                marginLeft: "20%",
                marginTop: "10px",
              }}
            >
              {surveyData.device__device_name}
            </Text>
          </div>
        </div>

        <div>{analysisReport}</div>
      </Page>
    </Document>
  );

  return (
    <div>
      <PDFDownloadLink
        document={<MyDocument />}
        fileName={surveyID + "_Report" + ".pdf"}
      >
        {({ blob, url, loading, error }) =>
          loading ? (
            "Loading document..."
          ) : (
            <button className="btn btn-sm btn-success custom-btn-primary">
              <i className="fa fa-download"></i> Download
            </button>
          )
        }
      </PDFDownloadLink>
    </div>
  );
}

export default UserAnalysisReportDownload;
